// extracted by mini-css-extract-plugin
module.exports = {"section":"M_section__G9xq6"};